export const SIGN_UP_ROUTES = {
  TITLE: 'Sign Up',
  ABSOLUTE_PATH: '/sign-up',
  EXACT_PATH: '/sign-up',
};
